import { UserTypeOption } from '@/graphql/generated'
import { useUserLanguage } from '@/customHooks'

type ResponsabilityCardProps = {
  userTypeOption: UserTypeOption,
  percentage: string,
  amount: string,
  card?: boolean
}

const userTypeMapper = {
  [UserTypeOption.Manager]: {
    en: 'Manager',
    es: 'Administrador'
  },
  [UserTypeOption.Owner]: {
    en: 'Owner',
    es: 'Propietario'
  },
  [UserTypeOption.Supplier]: {
    en: 'Supplier',
    es: 'Proveedor'
  },
  [UserTypeOption.Tenant]: {
    en: 'Tenant',
    es: 'Inquilino'
  }
}

export const ResponsabilityCard = ({ userTypeOption, percentage, amount, card = false }: ResponsabilityCardProps) => {
  const userLanguage = useUserLanguage()
  const title = userLanguage === 'es'
    ? userTypeMapper[userTypeOption].es
    : userTypeMapper[userTypeOption].en

  return (
    <div
      className={`mb-4 box-border w-full rounded-base p-4 leading-[1.7rem] md:px-5 ${
        card
          ? 'bg-white shadow-[0_5px_15px_rgba(0,0,0,0.08)]'
          : 'bg-background2 shadow-none'
      }`}
    >
      <h2 className="mb-2 text-base font-semibold">{title}</h2>
      <p className="m-0 text-base font-light"><b>{percentage} %</b></p>
      <p className="m-0 text-base font-light">{amount} €</p>
    </div>
  )
}
